import { handleTemplateAnchorClick } from './templateUtils';

export interface TemplateSummaryItem {
  id: string;
  label: string;
  anchorId?: string;
  pageNumber?: number;
}

export type TemplateSummaryCardTone = 'sky' | 'pink' | 'green' | 'red';

const TONE_STYLES: Record<
  TemplateSummaryCardTone,
  { inset: string; badge: string }
> = {
  sky: {
    inset: 'shadow-[inset_0px_1px_0px_0px_#7dd3fc]',
    badge: 'bg-sky-100',
  },
  pink: {
    inset: 'shadow-[inset_0px_1px_0px_0px_#f9a8d4]',
    badge: 'bg-pink-100',
  },
  green: {
    inset: 'shadow-[inset_0px_1px_0px_0px_#4ade80]',
    badge: 'bg-green-200',
  },
  red: {
    inset: 'shadow-[inset_0px_1px_0px_0px_#f87171]',
    badge: 'bg-red-200',
  },
};

export interface TemplateSummaryCardProps {
  title: string;
  count: number;
  items: TemplateSummaryItem[];
  tone: TemplateSummaryCardTone;
}

export const TemplateSummaryCard = ({
  title,
  count,
  items,
  tone,
}: TemplateSummaryCardProps) => {
  const toneStyles = TONE_STYLES[tone];

  return (
    <div
      className={`flex flex-1 flex-col gap-3 rounded-sm border border-zinc-300 bg-white px-5 pt-5 pb-4 ${toneStyles.inset}`}
    >
      <div className="flex items-center gap-2.5">
        <p className="text-[15px] leading-tight font-bold tracking-[0.15px] text-black">
          {title}
        </p>
        <span
          className={`rounded-full px-2 py-1 text-[9px] leading-none font-semibold text-black ${toneStyles.badge}`}
        >
          {count}
        </span>
      </div>
      {items.length ? (
        <ul className="flex flex-col gap-1 pl-4 text-[10px] leading-tight text-blue-700">
          {items.map((item) => (
            <li key={item.id} className="list-disc">
              {item.anchorId ? (
                <div className="flex items-start justify-between gap-4">
                  <a
                    href={`#${item.anchorId}`}
                    className="min-w-0 flex-1 text-blue-700 underline-offset-2 hover:underline"
                    onClick={(event) =>
                      handleTemplateAnchorClick(event, item.anchorId!)
                    }
                  >
                    {item.label}
                  </a>
                  {item.pageNumber ? (
                    <span className="shrink-0 text-blue-700">
                      {`p. ${item.pageNumber}`}
                    </span>
                  ) : null}
                </div>
              ) : (
                item.label
              )}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-[10px] leading-tight text-zinc-500">
          No data available
        </p>
      )}
    </div>
  );
};
